import { createAsyncThunk } from '@reduxjs/toolkit';
import type { AppDispatch, RootState } from '~/store';
import { client, gql } from '~/apollo-client';
import { CommentType } from '../types';

const ADD_COMMENT_TO_UPDATE = gql`
  mutation addCommentToUpdate($input: AddCommentInput!) {
    addCommentToUpdate(input: $input) {
      success
    }
  }
`;

export const addCommentToUpdate = createAsyncThunk<
  unknown,
  { postId: string; text: string },
  { state: RootState; dispatch: AppDispatch }
>('posts/addCommentToUpdate', async ({ postId, text }) => {
  const response = await client.mutate<
    {
      addCommentToUpdate: {
        success: boolean;
      };
    },
    { input: { postId: string; text: string; type: CommentType } }
  >({
    mutation: ADD_COMMENT_TO_UPDATE,
    variables: { input: { postId, text, type: CommentType.Comment } },
  });

  return response.data;
});
